import { deleteProject, getProjectsListData } from "../services/projectService";
import { IEntityListApi } from "@pulsion/forms-designer-2";
  
export const projectsListApi: IEntityListApi = {
    getEntityRows: getProjectsListData, 
    deleteRow: deleteProject,
};